export default __webpack_public_path__ + "static/media/singleAnkleHopThumb.33dd4e76.png";